// PLUGINS IMPORTS //
import React from 'react'
import styled from 'styled-components/macro'

// COMPONENTS IMPORTS //
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //
import UnfoundImage from 'Assets/Images/illustrations/404.svg'

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const Unfound: React.FC<PropsType> = (props) => {
  return (
    <Wrapper>
      Project not found
      <Image src={UnfoundImage} />
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 26px;
  padding-top: 210px;
`

const Image = styled.img`
  width: 30%;
  border-radius: 100px;
  margin-top: 35px;
`

export default React.memo(Unfound, memoComparison)
